import React, { useMemo } from 'react';

import PillSwitcher from 'components/lib/PillSwitcher';
import { CompanyAICIStats } from 'types/recommendations';

import CompanyAiCompetitiveIntelligenceLaggingChipLabel from './CompanyAiCompetitiveIntelligenceLaggingChipLabel';
import { AI_CI_CATEGORIES, DEFAULT_LAGGING_COUNT, OVERALL_TAB_LABEL, OVERALL_VIEW_KEY } from './constants';
import { getCompanyAICICategoryLaggingCount } from './helpers';

type Props = {
  stats?: CompanyAICIStats;
  activeTab: string;
  onChange: (key: string) => void;
};

const CompanyAiCompetitiveIntelligenceCategoryPills = ({ stats, activeTab, onChange }: Props) => {
  const tabs = useMemo(
    () => [
      {
        key: OVERALL_VIEW_KEY,
        label: (
          <CompanyAiCompetitiveIntelligenceLaggingChipLabel
            label={OVERALL_TAB_LABEL}
            laggingCount={stats?.overall.lagging_count ?? DEFAULT_LAGGING_COUNT}
          />
        ),
      },
      ...AI_CI_CATEGORIES.map((category) => ({
        key: category.key,
        label: (
          <CompanyAiCompetitiveIntelligenceLaggingChipLabel
            label={category.label}
            laggingCount={getCompanyAICICategoryLaggingCount(stats?.categories, category.key)}
          />
        ),
      })),
    ],
    [stats?.categories, stats?.overall.lagging_count]
  );

  return (
    <PillSwitcher
      items={tabs}
      activeKey={activeTab}
      onChange={onChange}
      getItemTestId={(categoryKey) => `company-aici-category-pill-${categoryKey}`}
    />
  );
};

export default CompanyAiCompetitiveIntelligenceCategoryPills;
